module.exports = __webpack_public_path__ + "media/puzzle8_3.f20d7b72.mp3";